"use client";

import type { UserProfileDto } from "@unreserved/sdk";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface AuthStoreState {
  user: UserProfileDto | null;
  isAuthenticated: boolean;
  isAuthResolved: boolean;
}

interface AuthStoreActions {
  setUser: (user: UserProfileDto) => void;
  clearUser: () => void;
}

export type AuthStore = AuthStoreState & AuthStoreActions;

const initialState: AuthStoreState = {
  user: null,
  isAuthenticated: false,
  isAuthResolved: false,
};

export const useAuthStore = create<AuthStore>()(
  devtools(
    (set) => ({
      ...initialState,

      setUser: (user: UserProfileDto) => {
        set({
          user,
          isAuthenticated: true,
          isAuthResolved: true,
        });
      },

      clearUser: () => {
        set({ ...initialState, isAuthResolved: true });
      },
    }),
    {
      name: "auth-store",
      enabled: process.env.NODE_ENV === "development",
    },
  ),
);
